import { SmartTableCellProps } from '@/components/ui/daisy';
import { LessonBlockRef } from '@/models/ScheduledLesson';
import { formatUnitNamePrefix } from '@/utils/unit/name';

type UnitCellItem = {
  lessonBlock: Pick<LessonBlockRef, 'order'> | null;
};

export default function UnitCell({ item }: SmartTableCellProps<UnitCellItem>) {
  const { lessonBlock } = item;

  if (!lessonBlock) return null;

  return <>{formatUnitNamePrefix({ unitOrder: lessonBlock.order })}</>;
}
